import React, { PropsWithChildren } from 'react';
import InfoTracMenu from '../Menu/index';
import { cn } from '../../../../utils/styles';

interface IMainInfoTracLayout extends PropsWithChildren {
  className?: string;
  isOldPage?: boolean;
}

export default function MainInfoTracLayout({ children, className, isOldPage }: IMainInfoTracLayout) {
  return (
    <main className={cn('w-full', className)}>
      <InfoTracMenu isOldPage={isOldPage} />
      {children}
    </main>
  );
}

MainInfoTracLayout.defaultProps = {
  className: '',
  isOldPage: false,
};
